module.exports = __webpack_public_path__ + "img/IMG-20190904-WA0012.db2f06da.jpg";